import { th } from 'style/theme';
import styled from 'styled-components';
import { sizes } from 'style';
import {
  CardExpiryElement as _CardExpiryElement,
  CardNumberElement as _CardNumberElement,
  CardCvcElement as _CardCvcElement
} from '@stripe/react-stripe-js';
import {
  InputWrapper,
  customInputStyle
} from 'products/nomad_insurance/components/TextInput/styled';

export const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 450px;
  background-color: ${th('colors.fountainBlue+2')};
  padding: 16px;
  border-radius: 8px;

  @media ${sizes.desktop} {
    padding: 32px;
    border-radius: 16px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: flex-start;

  @media ${sizes.desktop} {
    gap: 16px;
  }
`;

export const IconRow = styled(Row)`
  gap: 4px;
  width: 100%;
  justify-content: flex-end;
`;

export const CustomInputWrapper = styled(InputWrapper)`
  flex: 1;
  border-radius: 16px;
  background-color: ${th('colors.fountainBlue+4')};

  .StripeElement--focus {
    outline: 4px solid rgb(138, 214, 215, 0.5);
    border: 1px solid ${th('colors.fountainBlue')};
  }
  .StripeElement--invalid {
    background-color: ${th('colors.fuzzyWuzzyBrown+4')};
    border: 1px solid ${th('colors.fuzzyWuzzyBrown')};
    outline: 4px solid rgb(199, 99, 88, 0.5);
    color: ${th('colors.black')};

    ~ label {
      color: ${th('colors.fuzzyWuzzyBrown')};
    }
  }
`;

export const PaymentCardInput = styled.input`
  ${customInputStyle};
`;

export const CardNumberElement = styled(PaymentCardInput).attrs({
  as: _CardNumberElement
})``;

export const CardExpiryElement = styled(PaymentCardInput).attrs({
  as: _CardExpiryElement
})``;

export const CardCvcElement = styled(PaymentCardInput).attrs({ as: _CardCvcElement })``;
